<app-modal>
	<div modal-header>
		<span i18n="Modal Titel for Register@@register.modal.title">Register</span>
	</div>
	<div modal-body>
		<form [formGroup]="registerForm">
			<div class="form-group">
				<label>Email address</label>
				<input type="email" formControlName="email" class="form-control">
			</div>
			<div class="form-group">
				<label>Password</label>
				<input type="password" class="form-control" formControlName="password">
				<label class="error">{{errorMessage}}</label>
				<label class="success">{{successMessage}}</label>
			</div>
			<button type="submit" (click)="tryRegister(registerForm.value)" class="btn btn-default">Register</button>
		</form>
	</div>
</app-modal>